import { Component, OnInit, Input } from '@angular/core';
import { CampaignService } from 'src/app/_services/campaign.service';
import { ActivatedRoute,  Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import moment from 'moment';
import { campaignListingPath, campaignStagesPath, getProjectNumberFromUrl } from '../campaign-scope.util';

@Component({
    selector: 'app-campaign-header',
    templateUrl: './campaign-header.component.html',
    styleUrls: ['./campaign-header.component.scss'],
    standalone: false
})
export class CampaignHeaderComponent implements OnInit {

  campaignData: any;
  showAddCandidatePage:any;
  filters:any;
  @Input() event: any;
  @Input() filtersApplied:any;
  campaign_status_id: number;
  currentCampaignId: any;
  campaignStatus:any;
  canEditCampaign = false;
  canAddCandidates = false;
  canChangeCampaignStatus = false;

  previousStatus: number;

  successMessage: string = '';
  errorMessage: string = '';

  projectNumber = getProjectNumberFromUrl();

  constructor( private emailCampaignService:CampaignService, private route: ActivatedRoute, private router: Router, private _localstorageservice: LocalStorageService ) { }

  get listingPath(): string[] {
    return campaignListingPath(this.projectNumber);
  }

  /** TRMS-2857 (spec 6.1 "Visibility"): e.g. "~65 candidates queued, estimated to start sending in 2 days". */
  get queueSummary(): string {
    const queue = this.campaignData?.queue;
    if (this.campaignData?.status !== 1 || !queue?.queued) return '';
    const parts = [`~${queue.queued} candidate${queue.queued === 1 ? '' : 's'} queued`];
    if (queue.estimatedStartAt) {
      const start = moment(queue.estimatedStartAt);
      parts.push(start.diff(moment()) <= 60 * 1000 ? 'sending now' : `estimated to start sending ${start.fromNow()}`);
    }
    const others = (queue.campaignsSharingMailbox || 1) - 1;
    if (others > 0) parts.push(`sharing your mailbox limit with ${others} other active campaign${others === 1 ? '' : 's'}`);
    return parts.join(', ');
  }

  ngOnInit() {
    this.currentCampaignId = +this.route.snapshot.paramMap.get('campaign_id')
    this.event.subscribe((res: any)=>{
      this.campaignData = res;
      this.campaignStatus = res.status;
      this.previousStatus = res.status;
      this.canEditCampaign = Boolean(res.permissions?.canEdit);
      this.canAddCandidates = Boolean(res.permissions?.canAddCandidates);
      this.canChangeCampaignStatus = Boolean(res.permissions?.canChangeStatus);
    })
    this.filtersApplied.subscribe((res:any)=>{
      this.showAddCandidatePage = res.addCandidate;
      this.filters= res.filters;
    })
  }

  changeStatus(event){
    if (!this.canChangeCampaignStatus) return;
    const created_by = this._localstorageservice.getItem('userdata')?.userid;
    this.emailCampaignService.updateCampaign({ status: event.value, campaign_id: this.currentCampaignId, created_by: created_by }).subscribe({
      next: ()=>{
        this.successMessage = 'Campaign status updated successfully.';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
      },
      error: (err: HttpErrorResponse)=>{
        this.campaignStatus = this.previousStatus;
        // Backend now names the specific campaign/project already Active (TRMS-2857) - show that
        // verbatim instead of rebuilding a generic count-only message that hides which one it is.
        if (err.error && err.error.message && Reflect.has(err.error, 'maxAllowedActiveCampaigns')) {
          this.errorMessage = err.error.message;
        } else {
          this.errorMessage = 'An error occurred while updating the campaign status. Please try again.';
        }
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      },
    })
  }
  navigateToStages(){
    this.router.navigate(campaignStagesPath(this.currentCampaignId, this.projectNumber))
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    return moment(dateString).format('DD MMM YYYY');
  }
}
